import { createInteriorRoomCalculator } from "./interior-room-shared.js";

/**
 * Laundry Room (Phase 13A). The one Phase 13A type where plumbing is
 * squarely "where applicable" (per the brief) rather than an edge case -
 * `laundry_room_plumbing_scope` is its own tiered question (relocating
 * hookups vs. adding a utility sink), independent of the generic
 * `plumbing_changes` yes/no/unknown flag every project type asks, since a
 * laundry room's plumbing work is central to the room rather than an
 * optional addition. No trim or windows/doors category - not typical
 * scope for a laundry room renovation.
 */
export const calculateLaundryRoom = createInteriorRoomCalculator({
  projectType: "laundry_room",
  anchorItemId: "laundry_room_base_renovation",
  tierFeatures: [
    {
      answerKey: "laundry_room_flooring_type",
      itemIdByTier: { not_changing: null, basic: "laundry_room_flooring_basic", mid_range: "laundry_room_flooring_mid", premium: "laundry_room_flooring_premium" },
      quantityFromSqft: true,
      excludedMessage: "Flooring is not changing - excluded from this estimate."
    },
    {
      answerKey: "laundry_room_painting",
      itemIdByTier: { not_included: null, walls_only: "laundry_room_painting_walls", full_room: "laundry_room_painting_full" },
      quantityFromSqft: true,
      excludedMessage: "Painting was not included - excluded from this estimate."
    },
    {
      answerKey: "laundry_room_lighting",
      itemIdByTier: { keep_existing: null, standard_swap: "laundry_room_lighting_standard", statement_lighting: "laundry_room_lighting_statement" },
      excludedMessage: "Lighting is not being upgraded - excluded from this estimate."
    },
    {
      answerKey: "laundry_room_built_ins",
      itemIdByTier: { none: null, standard: "laundry_room_built_ins_standard", custom: "laundry_room_built_ins_custom" },
      excludedMessage: "No cabinetry/folding station was requested - excluded from this estimate."
    },
    {
      answerKey: "laundry_room_plumbing_scope",
      itemIdByTier: {
        none: null,
        relocate_hookups: "laundry_room_plumbing_relocate_hookups",
        add_utility_sink: "laundry_room_plumbing_add_utility_sink"
      },
      excludedMessage: "No washer/dryer hookup relocation or utility sink was requested - excluded from this estimate."
    }
  ],
  electricalItemId: "laundry_room_electrical",
  demolitionItemId: "laundry_room_demolition",
  accessibilityItemId: "laundry_room_accessibility",
  permitDesignItemId: "laundry_room_permit_design"
});
